export const LOADING_LIST_RENDA_MENSAL = "LOADING_LIST_RENDA_MENSAL";
export const SET_LIST_RENDA_MENSAL = "SET_LIST_RENDA_MENSAL";
export const LOADING_LIST_PATRIMONIO = "LOADING_LIST_PATRIMONIO";
export const SET_LIST_PATRIMONIO = "SET_LIST_PATRIMONIO";
